// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__Xc0O5","logo":"Header_logo__Kvi4G","navAndBtns":"Header_navAndBtns__RLh6T","nav":"Header_nav__sl702","btns":"Header_btns__oa5rz"};